import React, { FC, memo, useContext, useMemo } from 'react'
import { SolidButton } from 'react-components'
import { ThemeContext } from 'styled-components'
import ReactMarkdown from 'react-markdown'

import { TipTransport } from '../../transports/region-landing-page-transport'
import {
    DesktopButtonContainer,
    DesktopCardContainer,
    DesktopMarkdownText,
    CustomDot,
    ImageDesktopContainer,
    LogoContainer,
    LogoImage,
    LogoText,
    SliderContainer,
    Subtitle,
    TipsContent,
    Title,
} from './tips-section-styles'
import ImageLoadingComponent from '../app-components/image-loading-component'
import { useTranslation } from '../../hooks/locale'
import { useCurrentSlideIndex } from '../../hooks/carousel'

type Props = {
    tip: TipTransport
    totalItems: number
    location: string
}

const TipsSectionCardDesktop: FC<Props> = ({ tip, totalItems, location }) => {
    const { t } = useTranslation()
    const theme = useContext(ThemeContext)
    const _currentSlideIndex = useCurrentSlideIndex()

    const Dots = useMemo(() => {
        const DotsList = []
        for (let index = 0; index < totalItems; index++) {
            DotsList.push(<CustomDot slide={index} key={index} selected={index === _currentSlideIndex} />)
        }
        return DotsList
    }, [totalItems, _currentSlideIndex])

    return (
        <DesktopCardContainer>
            <ImageDesktopContainer>
                <LogoContainer>
                    <LogoImage />
                    <LogoText>{t('imageIconText')}</LogoText>
                </LogoContainer>
                <ImageLoadingComponent
                    src={tip.image?.formats?.large?.url || tip.image?.url}
                    alt={'tips-image'}
                    objectFit={'cover'}
                    borderRadius={`${theme.typography.border.radius.xLarge} 0 0
                        ${theme.typography.border.radius.xLarge}`}
                />
            </ImageDesktopContainer>
            <TipsContent>
                <Title>{tip.title}</Title>
                <Subtitle>{tip.subtitle}</Subtitle>
                <DesktopMarkdownText>
                    <ReactMarkdown>{tip.text}</ReactMarkdown>
                </DesktopMarkdownText>
                <DesktopButtonContainer>
                    <SolidButton
                        href={tip.cta?.url}
                        padding={`${theme.spacing.xSmall} ${theme.spacing.small}`}
                        width={theme.layout.fill}
                    >
                        {`${t('tipsSectionButtonText')} ${location}`}
                    </SolidButton>
                </DesktopButtonContainer>
                <SliderContainer>{Dots}</SliderContainer>
            </TipsContent>
        </DesktopCardContainer>
    )
}

export default memo(TipsSectionCardDesktop)
